import Home from "../Home"

const WomenClothing = () => {
  return (
    <Home url={"https://fakestoreapi.com/products/category/women's clothing"}/>

  )
}

export default WomenClothing